import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Password updated! Please sign in.");
      nav("/admin/login");
    } catch (err) { toast.error(apiErr(err.response?.data?.detail) || "Reset failed"); }
  };
  return (
    <div className="min-h-screen grid place-items-center bg-[#0A0A0A] grain px-4">
      <div className="w-full max-w-md card-surface rounded-2xl p-8 gold-glow">
        <h1 className="font-display text-2xl text-center">Set a new password</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input type="password" required minLength={6} placeholder="New password (min 6 chars)" value={pw} onChange={(e) => setPw(e.target.value)}
            className="w-full rounded-lg bg-black/50 border border-white/10 px-3 py-3 text-sm outline-none focus:border-[#D4AF37]" />
          <button className="w-full rounded-lg bg-gradient-to-r from-[#D4AF37] to-[#F0D77B] py-3 font-semibold text-[#0A0A0A]">Update password</button>
        </form>
        <div className="text-center mt-6"><Link to="/admin/login" className="text-xs text-white/50 hover:text-[#D4AF37]">← Back to login</Link></div>
      </div>
    </div>
  );
}
